import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useContext,} from 'react'
import {NullAsDefault} from 'views/Shared'
import {IoArrowBack} from "react-icons/io5";

const GoBackAction = ({
  title,
  className,
  extra = null,
  Wrapper = 'div',
}) => {
  const t = useTranslate()

  const { handleGoBack = NullAsDefault } =
    useContext(NavigationContext)

  return (
    <Wrapper
      className={classNames(
        'flex items-center',
        className
      )}>
      <IoArrowBack
          size={17}
          onClick={() => handleGoBack()}
          className="text-color-400 hover:text-color-100 cursor-pointer"
      />
      {title && (
        <span className="flex items-center flex-1 font-semibold truncate">
          {t(title)}
        </span>
      )}
      {extra}
    </Wrapper>
  )
}

export default GoBackAction
